var VoidEnum;
(function(VoidEnum2) {
  VoidEnum2["void"] = "_void";
  VoidEnum2["novoid"] = "_novoid";
})(VoidEnum || (VoidEnum = {}));
export var RefProps;
(function(RefProps2) {
  RefProps2["name"] = "refPropsName";
  RefProps2["path"] = "refPropsPath";
  RefProps2["noVoidPath"] = "noVoidPath";
  RefProps2["withAttr"] = "withAttr";
  RefProps2["setAlias"] = "setAlias";
  RefProps2["setVoid"] = "setVoid";
  RefProps2["isVoid"] = "isVoid";
  RefProps2["isAlias"] = "isAlias";
  RefProps2["nameCollection"] = "nameCollection";
  RefProps2["arrayItem"] = "item";
  RefProps2["relative"] = "relative";
  RefProps2["parent"] = "parent";
  RefProps2["clear"] = "clear";
})(RefProps || (RefProps = {}));
